module.exports = __webpack_public_path__ + "assets/img/82cf08f6895aa1ff4759f77bb8cefbec.png";